<div class="maps-surface-host">
    <maps-header></maps-header>

    <maps-search-page *ngIf="location === 'search'"></maps-search-page>
    <maps-admin-dashboard *ngIf="location === 'admin-dashboard' && isAdmin"></maps-admin-dashboard>
    <maps-admin-configuration *ngIf="location === 'admin-configuration' && isAdmin"></maps-admin-configuration>
    <maps-admin-partners *ngIf="location === 'admin-partners' && isAdmin"></maps-admin-partners>

    <maps-saved-searches-drawer></maps-saved-searches-drawer>
</div>
